import { QuestionTypeEnum } from '@/models/Question';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';

export default function toQuestionIdentityKey(
  type: QuestionTypeEnum | ActivityTypeEnum,
  identifier: string,
) {
  return `${type}:${identifier}`;
}
